import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LockIcon, MailIcon } from 'lucide-react';
export function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const {
    login
  } = useAuth();
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    try {
      await login(email, password);
      navigate('/dashboard');
    } catch (err) {
      setError('Invalid email or password');
    } finally {
      setIsLoading(false);
    }
  };
  return <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-white to-sky-50 flex items-center justify-center px-4 py-12" data-id="element-257">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="w-full max-w-md" data-id="element-258">
        <div className="text-center mb-8" data-id="element-259">
          <Link to="/" className="text-3xl font-bold text-black inline-block mb-2" data-id="element-260">
            WellAd<span className="text-indigo-600" data-id="element-261">.</span>
          </Link>
          <h2 className="text-2xl md:text-3xl font-bold text-black mb-2" data-id="element-262">
            Welcome Back
          </h2>
          <p className="text-gray-600" data-id="element-263">Sign in to access your dashboard</p>
        </div>
        <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100" data-id="element-264">
          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-265">
            <div data-id="element-266">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-267">
                Email Address
              </label>
              <div className="relative" data-id="element-268">
                <MailIcon className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={20} data-id="element-269" />
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} className="w-full pl-10 pr-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition" placeholder="you@example.com" required data-id="element-270" />
              </div>
            </div>
            <div data-id="element-271">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-272">
                Password
              </label>
              <div className="relative" data-id="element-273">
                <LockIcon className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={20} data-id="element-274" />
                <input type="password" value={password} onChange={e => setPassword(e.target.value)} className="w-full pl-10 pr-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition" placeholder="Enter your password" required data-id="element-275" />
              </div>
            </div>
            {error && <div className="bg-red-50 text-red-600 px-4 py-3 rounded-lg text-sm" data-id="element-276">
                {error}
              </div>}
            <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} type="submit" disabled={isLoading} className="w-full bg-black text-white py-3 rounded-full font-semibold hover:bg-gray-900 transition-all disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-277">
              {isLoading ? 'Signing in...' : 'Sign In'}
            </motion.button>
          </form>
          <div className="mt-6 text-center" data-id="element-278">
            <p className="text-gray-600 text-sm" data-id="element-279">
              Don't have an account?{' '}
              <Link to="/signup" className="text-indigo-600 font-semibold hover:text-indigo-700" data-id="element-280">
                Sign up
              </Link>
            </p>
          </div>
        </div>
        <div className="mt-6 text-center" data-id="element-281">
          <Link to="/" className="text-gray-600 text-sm hover:text-black" data-id="element-282">
            ← Back to home
          </Link>
        </div>
      </motion.div>
    </div>;
}